<template>
    <!-- 订单详情 -->
    <div  class="Booking">
        <div class="jindutiao">
            <div class="title">订单状态</div>
            <el-steps  v-if="form.order_status!=11" :active="form.order_status" >
                <el-step icon="el-icon-success" title="订舱中" :description="form.one_confirm_time"></el-step>
                <el-step icon="el-icon-success" title="已放舱" :description="form.two_status_time"></el-step>
                <el-step icon="el-icon-success" title="已截单" :description="form.three_status_time"></el-step>
                <el-step icon="el-icon-success" title="待离港" :description="form.four_status_time"></el-step>
                <el-step icon="el-icon-success" title="已离港" :description="form.five_status_time"></el-step>
                <el-step icon="el-icon-success" title="已完成" :description="form.six_status_time"></el-step>
            </el-steps>
            <div class="quxiaodd" v-if="form.order_status==11" :active="form.order_status">
                <el-steps align-center :active="form.order_status" >
                    <!-- :description="form.four_status_time" -->
                    <el-step icon="el-icon-error" title="用户取消订单"></el-step>
                </el-steps>
            </div>
        </div>
        <div class="contenmt">
            <!-- 订单信息 -->
            <div>
                <div class="con-tit">
                    订单信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            订单编号
                        </div>
                        <div class="nr-c">
                            {{form.order_sn}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            订单类型
                        </div>
                        <div class="nr-c">
                            精选运价
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            下单时间
                        </div>
                        <div class="nr-c">
                            2024/11/15 16:44:00
                        </div>
                    </div>
                </div>
            </div>

            <!-- 基本信息 -->
            <div>
                <div class="con-tit">
                    基本信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            船公司
                        </div>
                        <div class="nr-c">
                            {{shippingCode}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            起运港
                        </div>
                        <div class="nr-c">
                            {{form.pol_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港
                        </div>
                        <div class="nr-c">
                            {{form.pod_name}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            ETD
                        </div>
                        <div class="nr-c">
                            {{form.etd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            ETA
                        </div>
                        <div class="nr-c">
                            {{form.eta}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            船期
                        </div>
                        <div class="nr-c">
                            {{form.shipping_date}}天
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            运输条款
                        </div>
                        <div class="nr-c">
                            {{form.transportation_terms}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            箱源
                        </div>
                        <div class="nr-c">
                           {{form.box_source}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            中转/直达
                        </div>
                        <div class="nr-c">
                            {{form.is_transit==1?'中转':'直达'}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            截单时间
                        </div>
                        <div class="nr-c">
                            {{form.cutoff_bill_of_lading_time}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            进港/开港时间
                        </div>
                        <div>
                            <div  class="nr-c">{{form.cyOpen}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            截港时间
                        </div>
                        <div>
                            <div  class="nr-c">{{form.cutoff_enter_the_port_time}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            提单类型
                        </div>
                        <div class="nr-c">
                            {{form.bill_of_lading_type_desc}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            品名要求
                        </div>
                        <el-popover placement="bottom" width="200" trigger="click">
                            <p v-for="it in form.product_name" :key="it">
                                {{ it }}
                            </p>
                            <div class="nr-c chakan" slot="reference">点击查看</div>
                        </el-popover>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            亏舱费
                        </div>
                        <div class="nr-c dongjie">
                            CNY {{form.dead_freight}}
                            <span v-if="form.dead_freight_status==1">冻结中</span>
                            <span v-if="form.dead_freight_status==2">已解冻</span>
                            <span v-if="form.dead_freight_status==3">已扣款</span>
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            付款方式
                        </div>
                        <div class="nr-c">
                            {{form.pay_method==1?'预付':'到付'}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            航线
                        </div>
                        <div class="nr-c">
                            {{form.routeCd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港免堆/免用箱
                        </div>
                        <div class="nr-c">
                            {{form.freetime_desc}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            客服代码
                        </div>
                        <div class="nr-c">
                            {{form.sales_code}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- HS(海关编号) -->
            <div>
                <div class="con-tit">
                    HS(海关编号)
                </div>
                <div class="neirong">
                    <div class="nr" 
                    v-for="(item,index) in form.hs" 
                    :key="index"
                    :class="{'nryi':index%4!=0}">
                        <div class="nr-t">
                            HS(海关编号)
                        </div>
                        <div class="nr-c">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 集装箱信息 -->
            <div>
                <div class="con-tit">
                    集装箱信息
                </div>
                <el-table
                    :data="form.boxtype"
                    style="width: 100%"
                    :header-cell-style="{ background: '#f9f9f9' }"
                >
                    <el-table-column prop="box_type" label="箱型"> </el-table-column>
                    <el-table-column prop="weight" label="箱重(kgs)"> </el-table-column>
                    <el-table-column prop="overweight" label="超重限制">
                        <template slot-scope="scope">
                           {{scope.row.overweight==0?'不限重':'限重'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="weight_limit" label="限重规则" width="500">
                        <template slot-scope="scope">
                        <div v-if="scope.row.weight_limit==''">--</div>
                        <div v-else>
                          <el-table
                          border
                            :data="scope.row.weight_limit">
                            <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column property="overweight_fees" label="超重费用">
                                <template slot-scope="scopeItem">
                                    USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 货物信息 -->
            <div>
                <div class="con-tit">
                    货物信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            包装单位
                        </div>
                        <div class="nr-c">
                            {{form.packing_unit}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            件数
                        </div>
                        <div class="nr-c">
                            {{form.quantity}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            总重量(kgs)
                        </div>
                        <div class="nr-c">
                            {{form.totle_weight}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            体积(cbm)
                        </div>
                        <div class="nr-c">
                            {{form.totle_volume}}
                        </div>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            唛头
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.shipping_mark}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.shipping_mark"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            货物描述
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.describe}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.describe"></el-input>
                    </div>
                </div>
            </div>

            <!-- 收发通 -->
            <div>
                <div class="con-tit">
                    收发通
                </div>
                <div class="neirong">
                    <div class="nr xiaoInput">
                        <div class="nr-t">
                            发货人
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.shipper_mawb}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.shipper_mawb"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            收货人
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.consignee_mawb}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.consignee_mawb"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            通知人
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.notifier_mawb}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.notifier_mawb"></el-input>
                    </div>
                </div>
            </div>

            <!-- 订舱联系人 -->
            <div>
                <div class="con-tit">
                    订舱联系人
                </div>
                <div class="neirong yxnr">
                    <div class="nr">
                        <div class="nr-t">
                            订舱联系人
                        </div>
                        <div class="nr-c">
                            {{form.linkman}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            联系人电话
                        </div>
                        <div class="nr-c">
                            {{form.linkman_phone}}
                        </div>
                    </div>
                    <div class="nr"
                    v-for="(item,index) in form.email" 
                    :key="index"
                    :class="{'nryi':(index+2)%3!=0}">
                        <div class="nr-t">
                            联系人邮箱
                        </div>
                        <div class="nr-c">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 附件 -->
            <div>
                <div class="con-tit">
                    附件
                </div>
                <div class="neirong yxnr">
                    <div class="nr"
                    v-for="(item,index) in form.files" 
                    :key="index"
                    :class="{'nryi':index%3!=0}">
                        <div class="nr-t" v-if="item.type==1">订单附件</div>
                        <div class="nr-t" v-if="item.type==2">订单委托书</div>
                        <div class="nr-t" v-if="item.type==3">订舱确认书-主单</div>
                        <div class="nr-t" v-if="item.type==31">订舱确认书-分单</div>
                        <div class="nr-t" v-if="item.type==4">截单确认书-主单</div>
                        <div class="nr-t" v-if="item.type==41">截单确认书-分单</div>
                        <div class="nr-t" v-if="item.type==5">提单确认书-主单</div>
                        <div class="nr-t" v-if="item.type==51">提单确认书-分单</div>
                        <div class="nr-c con-up">
                            <div>
                                <i class="el-icon-success"></i>
                                <span class="name">{{item.file_name}}</span>
                            </div>
                            <el-button @click="download(item)" class="el-butnm del" type="text">下载</el-button>
                        </div>
                    </div>
                    <!-- <div class="nr nryi">
                        <div class="nr-t">
                            托运书
                        </div>
                        <div class="nr-c con-up">
                            <div>
                                <i class="el-icon-success"></i>
                                <span class="name">nnnn</span>
                            </div>
                            <el-button class="el-butnm del" type="text">下载</el-button>
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- 订单备注 -->
            <div>
                <div class="con-tit">
                    订单备注
                </div>
                <div class="neirong">
                    <div class="nr daInput">
                        <div class="nr-t">
                            备注内容
                        </div>
                        <!-- <p class="nr-c nr-csan">
                            {{form.order_remarks}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.order_remarks"></el-input>
                    </div>
                </div>
            </div>

            <div class="btnss">
                <el-button  v-if="form.status==1" class="quxiao"  @click="dialogFormVisible = true">取消订单</el-button>
                <!-- <el-button class="yulan">预览</el-button> -->
                <el-button class="daochu" @click="daochu">导出</el-button>
            </div>
        </div>

    <!-- 取消订单原因 -->
    <el-dialog title="订单取消" :visible.sync="dialogFormVisible">
      <el-form :model="cancelForm">
        <el-form-item label="取消原因" >
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="cancelForm.cancel_reason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"  @click="cancellation">确 定</el-button>
      </div>
    </el-dialog>
    </div>
</template>
    
<script>
import { myOrderDetail,jxCancelOrder,createOrderInfo } from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            active: 1,
            headers:{
                token: localStorage.getItem('token')
            },
            form:{},
            order_id: sessionStorage.getItem('itemId'),
            dialogFormVisible:false,
            cancelForm:{
                order_id:'',
                cancel_reason:''
            },
            shippingCode:''
        }
    },
    methods: {
        async getDetails(){
            try {
                const res = await myOrderDetail({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.form = res.data
                    this.shippingCode=res.data.shipping_company.name_cn+'-'+res.data.shipping_company.name_en
                    
                    if(this.form.confirm_status==3 || this.form.confirm_status==31 || this.form.confirm_status==4){
                        this.active=2
                    }else if(this.form.confirm_status==5){
                        this.active=3
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
            // 取消订单
        async cancellation(){
            if (this.cancelForm.cancel_reason.trim()==''){
                this.$message({
                type:'error',
                message:'取消原因不能为空'
                })
            }else{
                try {
                    this.cancelForm.order_id=this.$route.query.id
                    const res = await jxCancelOrder(this.cancelForm,this.headers)
                    if(res.code==1){
                        this.$message({
                        type:'success',
                        message:'订单取消成功'
                        })
                        this.dialogFormVisible = false
                        this.form.order_status=7
                    }else{
                    this.$message({
                        type:'error',
                        message:res.message
                    })
                    }
                } catch (error) {
                    console.log(error,'失败');
                }
            }
        },
        // 文件下载
        download(e) {
            const link = document.createElement('a');
            link.href = e.file_url;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async daochu(){
            try {
                const res = await createOrderInfo({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    // this.form = res.data
                    this.$message({
                        type:'success',
                        message:'导出成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.url;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:'导出失败'
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        }
    },
    mounted(){
        this.getDetails()
    }
}
</script>
    
<style style lang="scss" scoped>
.Booking{
    background: pink;
}

.jindutiao{
    width: 1136px;
    height: 180px;
    background: #F9F9F9;
    border-radius: 0px 0px 0px 0px;

    .title{
        padding-top: 24px;
        padding-left: 24px;
        padding-bottom: 20px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .el-steps{
        padding: 0 60px;
        justify-content: center;
    }
    :deep(.el-steps){
        .el-step__icon{
            background: #F9F9F9;
        }
    }
}

.xiaoInput{
    :deep(.el-textarea){
        width: 260px;
        background: #F9F9F9;
        border-radius: 9px 9px 9px 9px;
        .el-textarea__inner {
            width: 260px;
            height: 120px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.daInput{
    :deep(.el-textarea){
        width: 1044px;
        background: #F9F9F9;
        border-radius: 9px 9px 9px 9px;
        .el-textarea__inner {
            width: 1044px;
            height: 200px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.contenmt{
    background: #fff;
    padding: 20px;

    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .nryi{
          margin-left: 30px;  
        }


        .nr-t{
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606260;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;
        }

        .nr-cer{
            height: 120px;
            margin: 0;
            overflow:hidden;
            display: -webkit-box;  
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis; 
        }

        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }

        .chakan{
            text-align: center;

            cursor: pointer;

            color: #0073F5;
        }

        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;

                width: 48px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }

        .con-up{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                display: flex;
                align-items: center;
            }
            i{
                font-size: 16px;
                color: #00b53c;
                margin-right: 9px;
            }

            .name{
                width: 130px;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #333333;
                font-style: normal;
                text-transform: none;
            }

            .el-butnm{
                color: #0073F5;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                font-style: normal;
                text-transform: none;

                height: 18px;
                padding: 0;
            }
        }
    }

    .yxnr{
        flex-wrap: wrap;
        .nr{
            margin-bottom: 16px;
        }
    }
}

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-bottom: 20px;
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }
}

.btnss{
    text-align: center;
    margin-top: 48px;
    .el-button{
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 0;
        font-size: 14px;
    }

    .quxiao{
        background: #F9F9F9;
        color: #999999;
    }

    .yulan{
        color: #0073F5;
        border: 1px solid #0073F5;
        background: #fff;
    }

    .daochu{
        background: #0073F5;
        color: #fff;
    }
}

.yimatou{
  font-size: 12px;
  color: #999;
}
</style>